import { __read, __spreadArray, __values } from "tslib";
import * as React from 'react';
import { getUserValue } from '../../../utils';
import { TravellerFieldEnum } from '@websky/graphql';
import { useTheme } from '../../../theme';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getSegments } from '../../../Checkout/store/order/selectors';
import SubsidiesSelectorRadio from '../SubsidiesSelector/SubsidiesSelectorRadio';
import { InfoDetails, Person } from '../../../Icons';
import cn from 'classnames';
import { Money } from '../../../Money';
import MediaQuery from '../../../MediaQuery/MediaQuery';
var SubsidiesResultPassenger = function (_a) {
    var _b;
    var passenger = _a.passenger, subsidiesResult = _a.subsidiesResult, availableSubsidies = _a.availableSubsidies, onSubsidySelect = _a.onSubsidySelect, selectedSubsidies = _a.selectedSubsidies, selectedSubsidiesPrice = _a.selectedSubsidiesPrice;
    var theme = useTheme('Subsidies').SubsidiesPassenger;
    var flightSegments = useSelector(getSegments);
    var subsidiesByType = useMemo(function () {
        var e_1, _a, e_2, _b;
        var result = new Map();
        try {
            for (var _c = __values(Object.entries(subsidiesResult)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = __read(_d.value, 2), subsidyResult = _e[1];
                var _loop_1 = function (subsidy) {
                    var subsidyType = availableSubsidies.find(function (availableSubsidy) { return availableSubsidy.id === subsidy.id; })
                        .type;
                    if (subsidyType) {
                        if (result.has(subsidyType)) {
                            result.set(subsidyType, result.get(subsidyType).concat(subsidy));
                        }
                        else {
                            result.set(subsidyType, [subsidy]);
                        }
                    }
                };
                try {
                    for (var subsidyResult_1 = (e_2 = void 0, __values(subsidyResult)), subsidyResult_1_1 = subsidyResult_1.next(); !subsidyResult_1_1.done; subsidyResult_1_1 = subsidyResult_1.next()) {
                        var subsidy = subsidyResult_1_1.value;
                        _loop_1(subsidy);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (subsidyResult_1_1 && !subsidyResult_1_1.done && (_b = subsidyResult_1.return)) _b.call(subsidyResult_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return result;
    }, [subsidiesResult]);
    var handleSelect = function (subsidies) { return onSubsidySelect(passenger.id, subsidies); };
    var passengerName = (React.createElement(React.Fragment, null,
        React.createElement(MediaQuery, { minWidth: 'mobile' },
            React.createElement("span", { className: theme.personIcon }, Person),
            getUserValue(passenger, TravellerFieldEnum.LastName),
            "\u00A0",
            getUserValue(passenger, TravellerFieldEnum.FirstName),
            "\u00A0",
            getUserValue(passenger, TravellerFieldEnum.MiddleName),
            ",\u00A0",
            getUserValue(passenger, TravellerFieldEnum.BirthDate)),
        React.createElement(MediaQuery, { maxWidth: 'mobile' },
            React.createElement("div", null,
                getUserValue(passenger, TravellerFieldEnum.LastName),
                "\u00A0"),
            React.createElement("div", null,
                getUserValue(passenger, TravellerFieldEnum.FirstName),
                "\u00A0"),
            React.createElement("div", null,
                getUserValue(passenger, TravellerFieldEnum.MiddleName),
                ",\u00A0"),
            React.createElement("div", null, getUserValue(passenger, TravellerFieldEnum.BirthDate)))));
    var isAllSubsidiesUnavailable = __spreadArray([], __read(subsidiesByType.entries()), false).every(function (_a) {
        var _b = __read(_a, 2), type = _b[0], segments = _b[1];
        return segments.every(function (segmentSubsidy) { return !!segmentSubsidy.rejectMessage; });
    });
    var prices = useMemo(function () {
        var e_3, _a, e_4, _b;
        var subsidyCurrency = null;
        var discountPrice = {
            currency: subsidyCurrency,
            amount: 0
        };
        var initialPrice = {
            currency: subsidyCurrency,
            amount: 0
        };
        var resultPrice = {
            currency: subsidyCurrency,
            amount: 0
        };
        try {
            for (var _c = __values(subsidiesByType.entries()), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = __read(_d.value, 2), subsidySegments = _e[1];
                try {
                    for (var subsidySegments_1 = (e_4 = void 0, __values(subsidySegments)), subsidySegments_1_1 = subsidySegments_1.next(); !subsidySegments_1_1.done; subsidySegments_1_1 = subsidySegments_1.next()) {
                        var subsidySegment = subsidySegments_1_1.value;
                        if (!subsidyCurrency && subsidySegment.discount.currency) {
                            subsidyCurrency = subsidySegment.discount.currency;
                        }
                        discountPrice.amount += subsidySegment.discount.amount;
                        initialPrice.amount += subsidySegment.initialPrice.amount;
                        resultPrice.amount += subsidySegment.resultPrice.amount;
                        discountPrice.currency = subsidySegment.discount.currency;
                        initialPrice.currency = subsidySegment.initialPrice.currency;
                        resultPrice.currency = subsidySegment.resultPrice.currency;
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (subsidySegments_1_1 && !subsidySegments_1_1.done && (_b = subsidySegments_1.return)) _b.call(subsidySegments_1);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return {
            discountPrice: discountPrice,
            initialPrice: initialPrice,
            resultPrice: resultPrice
        };
    }, [subsidiesResult, selectedSubsidiesPrice]);
    var priceDescription = selectedSubsidies.length ? (React.createElement(React.Fragment, null,
        React.createElement(Money, { moneyClassName: cn(theme.money, theme.money_old), money: prices.initialPrice }),
        React.createElement(Money, { moneyClassName: cn(theme.money), money: selectedSubsidiesPrice }))) : isAllSubsidiesUnavailable ? (React.createElement(Money, { moneyClassName: cn(theme.money, theme.money_unchaned), money: prices.initialPrice })) : (React.createElement(Money, { moneyClassName: cn(theme.money, theme.money_unchaned), money: prices.initialPrice }));
    return (React.createElement("div", { className: theme.container },
        React.createElement("div", { className: cn(theme.header, (_b = {}, _b[theme.unavailable] = isAllSubsidiesUnavailable, _b)) },
            React.createElement("div", { className: theme.passengerName }, passengerName),
            React.createElement("div", { className: theme.price }, priceDescription)),
        __spreadArray([], __read(subsidiesByType.entries()), false).map(function (_a) {
            var _b = __read(_a, 2), type = _b[0], segments = _b[1];
            if (isAllSubsidiesUnavailable) {
                return (React.createElement("div", { key: type, className: theme.unavailableMessage },
                    React.createElement("span", { className: theme.unavailableMessageIcon }, InfoDetails),
                    segments[0].rejectMessage));
            }
            return (React.createElement(SubsidiesSelectorRadio, { selectedSubsidies: selectedSubsidies, key: type, subsidiesSegments: segments, segments: flightSegments, onSelect: handleSelect, id: segments[0].id, type: type }));
        })));
};
export default SubsidiesResultPassenger;
